// Mapping of pet folders to their media files
export const petMediaFiles = {
  p1: [
    'WhatsApp Image 2025-12-25 at 9.04.24 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.04.26 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.04.34 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.04.37 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.04.39 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.04.45 PM.jpeg',
    'WhatsApp Video 2025-12-25 at 9.04.18 PM.mp4',
    'WhatsApp Video 2025-12-25 at 9.04.22 PM.mp4',
    'WhatsApp Video 2025-12-25 at 9.04.31 PM.mp4',
    'WhatsApp Video 2025-12-25 at 9.04.42 PM.mp4'
  ],
  p2: [
    'WhatsApp Image 2025-12-25 at 9.13.53 PM.jpeg',
    'WhatsApp Video 2025-12-25 at 9.13.53 PM.mp4',
    'WhatsApp Video 2025-12-25 at 9.13.54 PM (1).mp4',
    'WhatsApp Video 2025-12-25 at 9.13.54 PM.mp4'
  ],
  p3: [
    'WhatsApp Image 2025-12-25 at 9.14.46 PM (1).jpeg',
    'WhatsApp Image 2025-12-25 at 9.14.46 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.14.47 PM (1).jpeg',
    'WhatsApp Image 2025-12-25 at 9.14.47 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.14.48 PM (1).jpeg',
    'WhatsApp Image 2025-12-25 at 9.14.48 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.14.49 PM.jpeg',
    'WhatsApp Video 2025-12-25 at 9.14.47 PM.mp4',
    'WhatsApp Video 2025-12-25 at 9.14.48 PM.mp4'
  ],
  p4: [
    'WhatsApp Image 2025-12-25 at 9.15.41 PM (1).jpeg',
    'WhatsApp Image 2025-12-25 at 9.15.41 PM (2).jpeg',
    'WhatsApp Image 2025-12-25 at 9.15.41 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.15.42 PM.jpeg',
    'WhatsApp Video 2025-12-25 at 9.15.40 PM.mp4'
  ],
  p5: [
    'WhatsApp Image 2025-12-25 at 9.16.40 PM (1).jpeg',
    'WhatsApp Image 2025-12-25 at 9.16.40 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.16.41 PM (1).jpeg',
    'WhatsApp Image 2025-12-25 at 9.16.41 PM (2).jpeg',
    'WhatsApp Image 2025-12-25 at 9.16.41 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.16.42 PM.jpeg'
  ],
  p6: [
    'lab.jpeg'
  ],
  p7: [
    'WhatsApp Image 2025-12-25 at 9.18.30 PM.jpeg'
  ],
  p8: [
    'WhatsApp Image 2025-12-25 at 9.19.13 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.19.14 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.19.15 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.19.16 PM (1).jpeg',
    'WhatsApp Image 2025-12-25 at 9.19.16 PM (2).jpeg',
    'WhatsApp Image 2025-12-25 at 9.19.16 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.19.17 PM (1).jpeg',
    'WhatsApp Image 2025-12-25 at 9.19.17 PM (2).jpeg',
    'WhatsApp Image 2025-12-25 at 9.19.17 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.19.18 PM (1).jpeg',
    'WhatsApp Image 2025-12-25 at 9.19.18 PM (2).jpeg',
    'WhatsApp Image 2025-12-25 at 9.19.18 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.19.19 PM (1).jpeg',
    'WhatsApp Image 2025-12-25 at 9.19.19 PM (2).jpeg',
    'WhatsApp Image 2025-12-25 at 9.19.19 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.19.20 PM.jpeg'
  ],
  p9: [
    'WhatsApp Image 2025-12-25 at 9.20.24 PM (1).jpeg',
    'WhatsApp Image 2025-12-25 at 9.20.24 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.20.25 PM (1).jpeg',
    'WhatsApp Image 2025-12-25 at 9.20.25 PM.jpeg'
  ],
  p10: [
    'WhatsApp Image 2025-12-25 at 9.21.04 PM (1).jpeg',
    'WhatsApp Image 2025-12-25 at 9.21.04 PM (2).jpeg',
    'WhatsApp Image 2025-12-25 at 9.21.04 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.21.05 PM.jpeg'
  ],
  p11: [
    'WhatsApp Image 2025-12-25 at 9.21.54 PM (1).jpeg',
    'WhatsApp Image 2025-12-25 at 9.21.54 PM (2).jpeg',
    'WhatsApp Image 2025-12-25 at 9.21.54 PM (3).jpeg',
    'WhatsApp Image 2025-12-25 at 9.21.54 PM.jpeg'
  ],
  p12: [
    'WhatsApp Image 2025-12-25 at 9.22.34 PM (1).jpeg',
    'WhatsApp Image 2025-12-25 at 9.22.34 PM (2).jpeg',
    'WhatsApp Image 2025-12-25 at 9.22.34 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.22.35 PM (1).jpeg',
    'WhatsApp Image 2025-12-25 at 9.22.35 PM (2).jpeg',
    'WhatsApp Image 2025-12-25 at 9.22.35 PM.jpeg',
    'WhatsApp Image 2025-12-25 at 9.22.36 PM (1).jpeg',
    'WhatsApp Image 2025-12-25 at 9.22.36 PM (2).jpeg',
    'WhatsApp Image 2025-12-25 at 9.22.36 PM.jpeg'
  ]
};

// Helper function to get media URLs for a pet folder
export const getPetMedia = (folder) => {
  const files = petMediaFiles[folder] || [];
  return files.map(file => ({
    url: `/pets/${folder}/${encodeURIComponent(file)}`,
    type: file.endsWith('.mp4') ? 'video' : 'image',
    filename: file
  }));
};
